module.exports = __webpack_public_path__ + "static/media/logoIg.0b45ab4c.png";